module.exports = __webpack_public_path__ + "static/media/dropdown.4b5cb350.svg";